import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import DataTable from './DataTable'
import { getList, deleteOne } from './BackendProvider'

// Wrapper component to provide navigation functionality
const ResourceWithRouter = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return <Resource {...props} navigate={navigate} location={location} />;
};

export default class Resource extends React.Component {
    constructor (props) {
        super(props)
        // Get query string params from URL and convert to filter object
        const queryParams = new URLSearchParams(window.location.search);
        const queryParamsArray = Array.from(queryParams.entries()).map(([key, value]) => ({
            key,
            value
        }));
        const filterFromParams = {};
        queryParamsArray.forEach(param => {
            filterFromParams[param.key] = param.value;
        });
        props.data.filter = {...props.data.filter, ...filterFromParams};
        
        this.state = {
            page: props.data.page ? props.data.page : 1,
            filter: props.data.filter ? props.data.filter : {},
            userfilter: props.data.userfilter ? props.data.userfilter : [],
            userFilterExpandable: props.data.userFilterExpandable ? props.data.userFilterExpandable : false,
            userFilterSimple: props.data.userFilterSimple ? props.data.userFilterSimple : false,
            userFilterAdvanced: props.data.userFilterAdvanced ? props.data.userFilterAdvanced : false,
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: props.loading ? props.loading : false,
            metadata: props.data.metadata,
            view: props.data.view ? props.data.view : {},
            onclick: props.data.onclick ? props.data.onclick : false,
            link: props.data.link ? props.data.link : false,
            url: props.data.url,
            queryParams: queryParamsArray,
            filterColumnWidth: props.data.filterColumnWidth ? props.data.filterColumnWidth : 4
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.loading !== this.props.loading) {
            this.setState({loading: this.props.loading});
            this.loadFromServer();
        }
    }
    loadFromServer() {
        this.setState({loading: true});
        const filter = this.state.filter;
        const qsFilter = [];
        if (filter !== undefined) {
            Object.keys(filter).forEach(key => {
                if (filter[key] instanceof Date) {
                    qsFilter.push({key: key, value: filter[key].toISOString()});
                } else {
                    qsFilter.push({key: key, value: filter[key]});
                }
            });
        // Append URL query params to filter
        // this.state.queryParams.forEach(param => {
        //     qsFilter.push({key: param.key, value: param.value});
        // });
        }
        qsFilter.push({key: 'page', value: this.state.page});

        getList(this.state.url, qsFilter).then(
            response => {
                if (response.data !== undefined && response.data.result === 'OK') {
                    this.setState({
                        datarows: response.data.data,
                        servermeta: response.data.metadata,
                        count: response.data.count,
                        rowsPerPage: response.data.rowsPerPage,
                        loading: false
                    })
                } else {
                    this.setState({loading: false});
                    toast.error("Something went wrong... backend not reachable. Try to reload page", {})
                }
            }
        ).catch(error => {
            this.setState({loading: false});
            if (error.response && error.response.data && error.response.data.result === 'ERROR') {
                Object.keys(error.response.data.message).forEach(key => {
                    toast.error(error.response.data.message[key][0], {});
                });
            } else {
                toast.error("Something went wrong... backend error", {});
            }
        });
    }
    onLoadMore() {
        var offset = this.state.offset + this.state.limit;
        this.setState({
                offset: offset
            }, function () {
                this.loadFromServer()
            }
        );
    }
    onFilter(filter) {
        // Create a new filter object that starts with queryParams
        const mergedFilter = {};
        this.state.queryParams.forEach(param => {
            mergedFilter[param.key] = param.value;
        });

        // Override with new filter values
        Object.keys(filter).forEach(key => {
            mergedFilter[key] = filter[key];
        });
        
        // Update filter with merged values
        const queryFilter = mergedFilter;
        this.setState({
                page: 1,
                filter:  queryFilter
            }, function () {
                this.loadFromServer()
            }
        );
        // Update URL with filter parameters
        const params = new URLSearchParams();
        
        // Add all filter parameters to URL
        Object.entries(mergedFilter).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                if (value instanceof Date) {
                    value = value.toISOString();
                } else if (typeof value === 'object' && value !== null) {
                    value = JSON.stringify(value);
                } 
                params.set(key, value);
            }
        });
        
        // Update URL without reloading page
        if (this.props.location && this.props.navigate) {
            const newUrl = this.props.location.pathname + '?' + params.toString();
            this.props.navigate(newUrl);
        } else {
            // Fallback to window.location if router props are not available
            const newUrl = window.location.pathname + '?' + params.toString();
            window.history.pushState({}, '', newUrl);
        }
    }
    onPageChange(page) {
        this.setState({
            page: page
        }, function () {
            this.loadFromServer()
        });
    }
    handleDelete(pk) {
        deleteOne(this.state.url, pk).then(
            response => {
                toast.success("Resource deleted successfully", {})
                this.loadFromServer()
            }
        ).catch(error => {
            toast.error("Error deleting resource: " + error.message, {})
        });
    }
    render() {
        var data = {
            data: this.state.datarows,
            metadata: this.state.servermeta
        };
        return (
            <div>
                <ToastContainer />
                <DataTable
                    data={data}
                    metadata={this.state.metadata}
                    view={this.state.view}
                    onclick={this.state.onclick}
                    link={this.state.link}
                    userfilter = {this.state.userfilter}
                    userFilterExpandable = {this.state.userFilterExpandable}
                    userFilterSimple = {this.state.userFilterSimple}
                    userFilterAdvanced = {this.state.userFilterAdvanced}
                    queryParams = {this.state.queryParams}
                    onFilter = { this.onFilter.bind(this) }
                    url={this.state.url}
                    urlattrs={this.props.urlattrs}
                    onLoadMore = { this.onLoadMore.bind(this) }
                    datalen = { this.state.datalen }
                    total = { this.state.count }
                    rowsPerPage = { this.state.rowsPerPage }
                    addButtonLink={this.props.addButtonLink}
                    addButtonText={this.props.addButtonText}
                    loading = { this.state.loading }
                    childProps={this.props.childProps}
                    onPageChange = { this.onPageChange.bind(this) }
                    handleDelete = { this.handleDelete.bind(this) }
                    filterColumnWidth = { this.state.filterColumnWidth }
                    download
                />
            </div>
        )
    }
}
